import { BoxStatus } from '@/models/box-status'
import { BoxStyle } from '@/models/box-style'
import { DoorType } from '@/models/door-type'
import {Sensor} from "@/models/sensor";

export class Box{
  id?: string;
  toiletId?: string;
  vacancyStatus?: {text: string; color: string};
  name?: string;
  boxStyle?: BoxStyle;
  options?: Array<string>;
  doorType?: DoorType;
  sensorList?: Array<Sensor>
  sensorMac?: string;
  sensorId?: string;
  status?: BoxStatus;

  constructor(params?: Partial<Box>) {
    Object.assign(this, params);
  }
}